export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11514.49cf7845.jpg";